import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.fabricationJobs.FabricationJobSummaryTable.';
  public static readonly jobNumberTitle = `${Id.prefix}jobNumberTitle`;
  public static readonly titleTitle = `${Id.prefix}titleTitle`;
  public static readonly statusTitle = `${Id.prefix}statusTitle`;
  public static readonly itemsTitle = `${Id.prefix}itemsTitle`;
  public static readonly createdTitle = `${Id.prefix}createdTitle`;
  public static readonly modifiedTitle = `${Id.prefix}modifiedTitle`;
  public static readonly authorTitle = `${Id.prefix}authorTitle`;
  public static readonly deleteMenuItem = `${Id.prefix}deleteMenuItem`;
  public static readonly deleteConfirmation = `${Id.prefix}deleteConfirmation`;
  public static readonly untitled = `${Id.prefix}untitled`;
}

export class LangFabricationJobSummaryTable {
  private constructor() {}
  public static jobNumberTitle(): string {
    return interpolate(Id.jobNumberTitle);
  }
  public static titleTitle(): string {
    return interpolate(Id.titleTitle);
  }
  public static statusTitle(): string {
    return interpolate(Id.statusTitle);
  }
  public static itemsTitle(): string {
    return interpolate(Id.itemsTitle);
  }
  public static createdTitle(): string {
    return interpolate(Id.createdTitle);
  }
  public static modifiedTitle(): string {
    return interpolate(Id.modifiedTitle);
  }
  public static authorTitle(): string {
    return interpolate(Id.authorTitle);
  }
  public static deleteMenuItem(): string {
    return interpolate(Id.deleteMenuItem);
  }
  public static deleteConfirmation(): string {
    return interpolate(Id.deleteConfirmation);
  }
  public static untitled(): string {
    return interpolate(Id.untitled);
  }
}

export class FabricationJobSummaryTableModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.jobNumberTitle, 'Job #', 'Column title for fabrication job number');
    register.add(Id.titleTitle, 'Title', 'Column title for fabrication job title');
    register.add(Id.statusTitle, 'Status', 'Column title for fabrication job status');
    register.add(Id.itemsTitle, 'Items', 'Column title for fabrication job item count');
    register.add(Id.createdTitle, 'Created', 'Column title for fabrication job creation date');
    register.add(Id.modifiedTitle, 'Modified', 'Column title for fabrication job last modified date');
    register.add(Id.authorTitle, "{{glossary 'author'}}", 'Column title for fabrication job author');
    register.add(Id.deleteMenuItem, 'Delete', 'Menu item to delete a fabrication job');
    register.add(
      Id.deleteConfirmation,
      'Are you sure you want to delete this fabrication job?',
      'Confirmation message for deleting a fabrication job'
    );
    register.add(Id.untitled, '(untitled)', 'Placeholder for untitled fabrication job');
  }
}
